import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Ng2Highcharts } from 'ng2-highcharts';
import { ChartsService } from 'app/charts.service';

@Component({
  selector: 'app-workout-view',
  templateUrl: './workout-view.component.html',
  styleUrls: ['./workout-view.component.scss']
})
export class WorkoutViewComponent implements OnInit {

  // Define some public variables
  workout: object = {};
  profileChartOptions: any;
  zoneChartOptions: any;

  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private apiService: ApiService,
    private hubService: HubService,
    private chartsService: ChartsService
  ) { }

  ngOnInit() {
    if (this.route.snapshot.params.id) {
      // load seletced workout
      this.getWorkout(this.route.snapshot.params.id);
    } else {
      // load a default workout 'DsilYBHkLD' = Unders and Overs
      this.getWorkout('DsilYBHkLD');
    }
  }

  // load our workout
  getWorkout(workout) {
    this.hubService.getResource('Workout', { "objectId": workout }, 1, null, null, null)
      .subscribe(
      workouts => {
        this.workout = workouts[0];
        this.buildProfile(this.workout['workoutType']);
        this.loaderService.setLoaded();
      },
      error => {
        // console.log(error);
      }
      );
  }

  /**
  * Build the profile config object for highcharts including the series data arrays
  * @param {Object} workout - the workout object retuned from the API
  */
  buildProfile(workoutType) {

    var workoutProfileObject = {};
    var workoutType = workoutType;
    var zonePowerTimes = [];
    if (workoutType == 'mmp') {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0, 0, 0];
    } else {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0];
    }
    var runningDuration = 0;
    var plotLinesLaps = [];

    // loop the segments and create the profile array data for highcharts
    for (var i = 0; i < this.workout['segments'].length; i++) {

      // add to the laps array if needed
      if (this.workout['segments'][i].lap === true) {
        plotLinesLaps.push({
          color: "rgba(0, 0, 0, .2)",
          dashStyle: "Dash",
          value: (runningDuration),
          width: "1",
          zIndex: 22,
          label: { enabled: false }
        });
      }

      // what zone is this segment
      let segmentZone = this.getMmpPowerZone(this.workout['segments'][i].start, 'ftp');

      // loop through the zones arrays and add this segment to the correct array and NULL
      // to the others to create breaks/gaps. This is so we can use miltiple series and so multiple colours
      for (var key in workoutProfileObject) {
        if (key != segmentZone.toString()) {
          workoutProfileObject[segmentZone].push([runningDuration, null]);
        } else {
          // profile
          workoutProfileObject[segmentZone].push([runningDuration, this.workout['segments'][i].start]);
          runningDuration += this.workout['segments'][i].duration;
          workoutProfileObject[segmentZone].push([runningDuration, this.workout['segments'][i].start]);
          // time in zone
          zonePowerTimes[segmentZone] += this.workout['segments'][i].duration;
        }
      }

    }

    // get the configs
    this.profileChartOptions = this.chartsService.workoutProfileChart(workoutProfileObject, workoutType, plotLinesLaps);
    this.zoneChartOptions = this.chartsService.workoutZoneChart(zonePowerTimes, workoutType);

  }

  getMmpPowerZone(percentMmpPower, workoutType) {

    const mmpPowerBands = [0, 35, 45, 55, 65, 75, 85, 100, 1000];
    const ftpPowerBands = [0, 55, 75, 90, 105, 120, 150, 1000];
    // const mmpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];
    // const ftpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];

    if (workoutType == 'ftp') {
      if (percentMmpPower > ftpPowerBands[0] && percentMmpPower < ftpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= ftpPowerBands[1] && percentMmpPower <= ftpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= ftpPowerBands[2] && percentMmpPower <= ftpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= ftpPowerBands[3] && percentMmpPower <= ftpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= ftpPowerBands[4] && percentMmpPower <= ftpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= ftpPowerBands[5] && percentMmpPower <= ftpPowerBands[6]) { return 5; }
      else { return 0; }
    } else {
      if (percentMmpPower > mmpPowerBands[0] && percentMmpPower < mmpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= mmpPowerBands[1] && percentMmpPower <= mmpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= mmpPowerBands[2] && percentMmpPower <= mmpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= mmpPowerBands[3] && percentMmpPower <= mmpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= mmpPowerBands[4] && percentMmpPower <= mmpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= mmpPowerBands[5] && percentMmpPower <= mmpPowerBands[6]) { return 5; }
      else if (percentMmpPower >= mmpPowerBands[6] && percentMmpPower <= mmpPowerBands[7]) { return 6; }
      else if (percentMmpPower >= mmpPowerBands[7] && percentMmpPower <= mmpPowerBands[8]) { return 7; }
      else { return 0; }
    }

  }

    /**
    * ---------------------------------------------
    * Format and download the workout for 3rd parties
    *
    * @param {string} `format` i.e. 'zwo'
    * ---------------------------------------------
    */
    exportWorkout(format='zwo'){
      // track the event
      // this.angulartics2.eventTrack.next({ action: 'Export Workout', properties: { category: 'Workouts', label: format } });
      
      // convert and download the Workout
      this.convert("test", format);
    }

  /**
    * ---------------------------------------------
    * Convert the workout to .zwo etc
    *
    * @param {array} `data` array of json objects
    * @param {string} `format` i.e. 'zwo'
    * ---------------------------------------------
    */
  convert(data, format='zwo', filenameSuffix=''){
    if(format === 'zwo'){

      let zwoSegments = "";

      for (var i = 0; i < this.workout['segments'].length; i++) {
        zwoSegments += `
        <SteadyState Duration="${this.workout['segments'][i].duration}" Power="${this.workout['segments'][i].start / 100}" pace="${this.workout['segments'][i].cadence}">
          <textevent timeoffset="${this.workout['segments'][i].flashNoteOffset}" message="${this.workout['segments'][i].flashNote}"/>
        </SteadyState>
        `;
      }

      // build complete zwo file
      let zwiftFile = `
      <workout_file>
          <author>Wattbike Hub+</author>
          <name>${this.workout['title']}</name>
          <description>${this.workout['intro']}</description>
          <sportType>bike</sportType>
          <tags>
              <tag name="Wattbike Hub+"/>
          </tags>
          <workout>
            ${zwoSegments}
          </workout>
      </workout_file>`;

      // force the download
      this.export(zwiftFile, 'zwo');

    }
  }

  /**
    * ---------------------------------------------
    * Force the file download
    *
    * @param {string} `data` i.e. string contents for the txt file
    * @param {string} `format` i.e. 'csv' or 'json'
    * ---------------------------------------------
    */
  export(data, format) {

    // Build file name
    const filename = "WB-HubPlus" + '-' + this.workout['title'] + '.' + format

    let blob = new Blob([data], { type: 'text/' + format });
    let url = window.URL.createObjectURL(blob);

    // trigger a download
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/workout-view/workout-view.component.ts